(function () {
  // Init all sections on DOM ready
  function ready(fn) {
    document.readyState !== "loading"
      ? fn()
      : document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    document
      .querySelectorAll('[data-section="mc-media-feature"]')
      .forEach(initSection);
  });

  function initSection(root) {
    const lottieEls = root.querySelectorAll(".mc-lottie[data-lottie]");
    if (lottieEls.length) {
      loadLottie()
        .then(function (lottie) {
          lottieEls.forEach(function (el) {
            const url = el.getAttribute("data-lottie");
            if (!url) return;
            lottie.loadAnimation({
              container: el,
              renderer: "svg",
              loop: true,
              autoplay: true,
              path: url,
            });
          });
        })
        .catch(function (err) {
          console.error("Lottie load failed:", err);
        });
    }
  }

  // Lazy-load lottie-web only once
  let lottiePromise = null;
  function loadLottie() {
    if (window.lottie) return Promise.resolve(window.lottie);
    if (lottiePromise) return lottiePromise;

    lottiePromise = new Promise(function (resolve, reject) {
      const s = document.createElement("script");
      s.src =
        "https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js";
      s.async = true;
      s.onload = function () {
        resolve(window.lottie);
      };
      s.onerror = function (e) {
        reject(e);
      };
      document.head.appendChild(s);
    });

    return lottiePromise;
  }
})();
